import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import {Observable, throwError, from} from 'rxjs';
import {map, catchError, retry, switchMap} from 'rxjs/operators';

import {TokenInterceptor} from './token.interceptor';
import {LanguageInterceptor} from './language.interceptor';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from "@app/core/services/auth.service";
import {ToastService} from "@shared/services/toast.service";
import {RequestSigner} from '../signing/request-signer.service';
// import {AuthService} from '@auth/auth.service';
// import {ToastrService} from 'ngx-toastr';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private tokenInterceptor: TokenInterceptor,
              public toastService: ToastService,
              private languageInterceptor: LanguageInterceptor,
              private requestSigner: RequestSigner,
              private router: Router, private auth: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Don't set Content-Type for FormData - browser must set multipart/form-data with boundary
    if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
      request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
    }
    request = this.tokenInterceptor.addToken(request);
    request = this.languageInterceptor.addLanguage(request);

    // Sign LAST, after url/header mutations, so the signed bytes match what goes on the wire.
    return from(this.sign(request)).pipe(
      switchMap(signed => this.handle(signed, next)));
  }

  /** Attach LYCHEE-SIGN-V1 headers when signing is enabled; pass through unchanged otherwise. */
  private async sign(request: HttpRequest<any>): Promise<HttpRequest<any>> {
    if (!this.requestSigner.enabled) {
      return request;
    }
    try {
      const headers = await this.requestSigner.signHeaders(request);
      if (!headers) {
        return request;
      }
      let signed = request;
      Object.keys(headers).forEach(name => {
        signed = signed.clone({headers: signed.headers.set(name, headers[name])});
      });
      return signed;
    } catch (e) {
      // Never let a signing failure break the request; server decides (off/shadow/enforce).
      console.error('Request signing failed', e);
      return request;
    }
  }

  private handle(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = error && error.error ? error.error.error : error.name;
        errorMessage = navigator.onLine ? errorMessage : 'No Internet Connection';
        if (error.status === 401) {
          this.auth.removeLocalStorageItemsWithoutLogin();
          void this.router.navigate(['/auth/login']);
          return throwError(error);
        } else {
          this.toastService.error(errorMessage);
        }
        return throwError(error);
      })
    );
  }
}
